export default __webpack_public_path__ + "static/media/aboutSection6.553a2dd0.png";